import React from "react";
import { PropTypes } from "prop-types";
import { useSelector } from "react-redux";
import Select from "react-select";

function UserCustomInput({ id, isDisabled, value, onChange, user_lang }) {
  const { storefront_project_params, locales } = useSelector(
    (state) => state.architectureReducer.project,
  );
  const { lang } = useSelector((state) => state.variableReducer);

  const customOptions =
    storefront_project_params?.user_custom_values &&
    typeof storefront_project_params?.user_custom_values?.[`${id}`] ===
      "object" &&
    storefront_project_params?.user_custom_values?.[`${id}`];

  const getCustomInput = (value) => {
    const json_str = locales?.[lang]?.login?.[id];

    if (json_str) return JSON.parse(json_str)?.[value];
  };

  const getDropdownOptions = () => {
    const options = customOptions[user_lang?.uuid] || customOptions[lang];

    if (options?.length > 0) {
      return options.map((item) => ({
        value: item,
        label: item,
      }));
    }
  };

  const renderInput = () => (
    <input
      id={id}
      disabled={isDisabled}
      value={value}
      type="text"
      className="editor-form-input-title"
      onChange={(e) => onChange(id, e.target)}
    />
  );

  const renderDropdown = () => (
    <Select
      name={id}
      isDisabled={isDisabled}
      onChange={(item) => onChange(id, item)}
      options={getDropdownOptions()}
      value={{ value, label: value }}
      placeholder=""
      className="editor-select editor-user-select-country"
      classNamePrefix="slct"
    />
  );

  return (
    <div className="editor-form-section">
      <div className="editor-form-section-title">{getCustomInput("label")}</div>
      <div className="editor-form-input-box-h full-w">
        {customOptions ? renderDropdown() : renderInput()}
      </div>
    </div>
  );
}

UserCustomInput.propTypes = {
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  value: PropTypes.string,
  user_lang: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default UserCustomInput;
